export default __webpack_public_path__ + "static/media/lawfirms&others.728cf1ba.svg";